'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.getIcon = exports.animate = undefined;

var _magicVirtualElement = require('magic-virtual-element');

var _magicVirtualElement2 = _interopRequireDefault(_magicVirtualElement);

var _inViewport = require('in-viewport');

var _inViewport2 = _interopRequireDefault(_inViewport);

var _animations = require('./animations');

var animations = _interopRequireWildcard(_animations);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var animate = exports.animate = function animate(animation, duration, iterations, element, handleAnimateFinnished) {
	var inViewportWatcher = (0, _inViewport2.default)(element, { failsafe: false, offset: 50 }, function () {
		animations[animation](element, iterations, parseInt(duration, 10));

		if (handleAnimateFinnished) {
			handleAnimateFinnished();
		}
	});

	return inViewportWatcher;
}; /** @jsx dom */
var getIcon = exports.getIcon = function getIcon(_ref) {
	var icon = _ref.icon,
	    iconColor = _ref.iconColor,
	    iconSize = _ref.iconSize,
	    iconClass = _ref.iconClass,
	    label = _ref.label,
	    onClick = _ref.onClick;

	if (!icon) {
		return label ? label : (0, _magicVirtualElement2.default)('noscript', null);
	}

	try {
		var parsedIcon = JSON.parse(icon);
		var fontSize = iconSize && iconSize.replace(',', '.') || '';
		var styles = {
			fontSize: '' + fontSize,
			color: '' + iconColor,
			display: 'inline-block'
		};

		return (0, _magicVirtualElement2.default)(
			'div',
			{ style: styles },
			(0, _magicVirtualElement2.default)('i', { key: '' + parsedIcon.x.name + parsedIcon.prefix, 'class': parsedIcon.prefix + ' fa-' + parsedIcon.x.name + ' ' + iconClass, onClick: onClick })
		);
	} catch (err) {
		return (0, _magicVirtualElement2.default)('noscript', null);
	}
};